var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.computedAs,
    {
      tag: "component",
      staticClass: "jade-list-item",
      class: _vm.computedClass,
      on: { click: () => _vm.$emit("onClick") },
    },
    [
      _vm.$slots.leading
        ? _c(
            "div",
            { staticClass: "jade-list-item__leading" },
            [_vm._t("leading")],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "jade-list-item__main" },
        [
          _c(
            "jade-list-item-content",
            _vm._b(
              {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "tooltip",
                      fn: function () {
                        return [_vm._t("tooltip")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              },
              "jade-list-item-content",
              _vm.$props,
              false
            )
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "jade-list-item__trailing" },
        [
          _c(
            "div",
            {
              staticClass: "trailing-text-align jade-list-item__trailing-item",
            },
            [
              _vm.$slots.trailing
                ? _vm._t("trailing")
                : _c(
                    "jade-text",
                    {
                      attrs: {
                        color: "medium",
                        variant: "text-medium",
                        weight: "medium",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.trailing) + " ")]
                  ),
            ],
            2
          ),
          _vm.navigation
            ? _c("jade-icon", {
                attrs: {
                  use: "chevron-right",
                  color: "low",
                  size: "medium",
                  "data-testid": "navigation",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }